import React, { useEffect, useState, useCallback } from 'react';
import { API_BASE_URL } from '../config';

const EXPIRY_TIME = 2 * 60 * 60 * 1000; // 2 hours in ms
const WARNING_TIME = 5 * 60 * 1000; // 5 mins in ms

function SessionManager() {
  const [showWarning, setShowWarning] = useState(false);

  const checkSession = useCallback(() => {
    const token = localStorage.getItem('dms_auth_token') || sessionStorage.getItem('dms_auth_token');
    if (!token) return;

    try {
      const base64Url = token.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) base64 += '=';
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      const payload = JSON.parse(jsonPayload);
      
      if (!payload.exp) return;

      const expTime = payload.exp * 1000;
      const currentTime = Date.now();
      const timeLeft = expTime - currentTime;

      if (timeLeft <= 0) {
        // Session expired
        alert(`LOGGING OUT FROM SessionManager! timeLeft: ${timeLeft}`);
        localStorage.removeItem('dms_auth_token');
        sessionStorage.removeItem('dms_auth_token');
        window.location.href = '#/';
        window.location.reload();
      } else if (timeLeft <= WARNING_TIME) {
        // Show warning
        setShowWarning(true);
      } else {
        setShowWarning(false);
      }
    } catch (e) {
      console.error("Error checking session", e);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(checkSession, 60000); // Check every minute
    checkSession();

    // Reset inactivity timer on user actions (optional if we want inactivity logout vs hard token logout)
    // The requirement says "Automatic logout after 2 hours inactivity".
    // Since JWT expires in 2h from issue, true inactivity would require sliding session / token refresh.
    // For now, we will strictly enforce the 2h JWT limit as per standard JWT design.

    return () => clearInterval(interval);
  }, [checkSession]);

  const handleLogout = () => {
    localStorage.removeItem('dms_auth_token');
    sessionStorage.removeItem('dms_auth_token');
    window.location.href = '#/';
    window.location.reload();
  };

  if (!showWarning) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 
      backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 9999,
      display: 'flex', justifyContent: 'center', alignItems: 'center'
    }}>
      <div style={{
        background: '#161b22', padding: '30px', borderRadius: '10px',
        border: '1px solid #d29922', textAlign: 'center', color: '#c9d1d9', maxWidth: '400px'
      }}>
        <h2 style={{ color: '#d29922', margin: '0 0 15px 0' }}>Session Expiring Soon</h2>
        <p>Your session will expire in less than 5 minutes due to inactivity. Please log back in to continue working.</p>
        <div style={{ marginTop: '20px' }}>
          <button onClick={handleLogout} style={{
            background: '#21262d', color: '#c9d1d9', border: '1px solid #30363d',
            padding: '8px 16px', borderRadius: '5px', cursor: 'pointer'
          }}>
            Log Out Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionManager;
